/**
* Marriage & Family Suite — Thai marriage registration, Non-O marriage, prenup,
* divorce, child custody, dependent visas. 10 services × 12 nationalities = 120 matrix pages.
*/
export interface MarriageService {
  slug: string; nameTh: string; nameEn: string; intent: string; turnaround: string; gov: string;
}

export const MARRIAGE_SERVICES: readonly MarriageService[] = [
  { slug: "registration", nameTh: "จดทะเบียนสมรสไทย-ต่างชาติ", nameEn: "Thai-Foreigner Marriage Registration", intent: "จดทะเบียนที่อำเภอไทย", turnaround: "1-2 สัปดาห์", gov: "อำเภอ/สถานทูต" },
  { slug: "affirmation", nameTh: "หนังสือรับรองสถานะโสด (Affirmation)", nameEn: "Affirmation of Freedom to Marry", intent: "ขอที่สถานทูตต้นทาง", turnaround: "3-7 วัน", gov: "สถานทูต + MoJ" },
  { slug: "non-o-marriage", nameTh: "วีซ่า Non-O ติดตามคู่สมรสไทย", nameEn: "Non-O Marriage Visa", intent: "อยู่กับคู่สมรสไทย 1 ปี", turnaround: "3-4 สัปดาห์", gov: "ตม." },
  { slug: "extension", nameTh: "ต่ออายุ Non-O สมรส (1 ปี)", nameEn: "Non-O Marriage Extension", intent: "ต่ออายุประจำปี ตม.7", turnaround: "1-2 สัปดาห์", gov: "ตม." },
  { slug: "prenup", nameTh: "สัญญาก่อนสมรส (Prenuptial Agreement)", nameEn: "Prenuptial Agreement", intent: "แยกทรัพย์ก่อนแต่ง", turnaround: "2-3 สัปดาห์", gov: "อำเภอ + ทนาย" },
  { slug: "divorce", nameTh: "หย่าไทย-ต่างชาติ", nameEn: "Thai-Foreigner Divorce", intent: "หย่าตกลง/หย่าฟ้อง", turnaround: "2 สัปดาห์ - 12 เดือน", gov: "อำเภอ/ศาลเยาวชนและครอบครัว" },
  { slug: "custody", nameTh: "อำนาจปกครองบุตร (Child Custody)", nameEn: "Child Custody & Guardianship", intent: "ตกลง/ฟ้องเกี่ยวกับบุตร", turnaround: "3-12 เดือน", gov: "ศาลเยาวชนและครอบครัว" },
  { slug: "adoption", nameTh: "รับบุตรบุญธรรม (Adoption)", nameEn: "Adoption of Thai Child", intent: "รับบุตรบุญธรรมในไทย", turnaround: "6-12 เดือน", gov: "พม. + ศาล" },
  { slug: "dependent-visa", nameTh: "วีซ่าผู้ติดตาม (Dependent)", nameEn: "Non-O Dependent Visa", intent: "ครอบครัวของ Non-B/LTR", turnaround: "3-4 สัปดาห์", gov: "ตม." },
  { slug: "citizenship-marriage", nameTh: "แปลงสัญชาติผ่านการสมรส", nameEn: "Naturalization via Marriage", intent: "ขอสัญชาติไทยผ่านคู่สมรส", turnaround: "24-36 เดือน", gov: "มท." },
] as const;

export interface MarriageCountry { slug: string; nameTh: string; nameEn: string; }
export const MARRIAGE_COUNTRIES: readonly MarriageCountry[] = [
  { slug: "usa", nameTh: "อเมริกา", nameEn: "United States" },
  { slug: "uk", nameTh: "สหราชอาณาจักร", nameEn: "United Kingdom" },
  { slug: "australia", nameTh: "ออสเตรเลีย", nameEn: "Australia" },
  { slug: "canada", nameTh: "แคนาดา", nameEn: "Canada" },
  { slug: "germany", nameTh: "เยอรมนี", nameEn: "Germany" },
  { slug: "france", nameTh: "ฝรั่งเศส", nameEn: "France" },
  { slug: "japan", nameTh: "ญี่ปุ่น", nameEn: "Japan" },
  { slug: "china", nameTh: "จีน", nameEn: "China" },
  { slug: "korea", nameTh: "เกาหลีใต้", nameEn: "South Korea" },
  { slug: "netherlands", nameTh: "เนเธอร์แลนด์", nameEn: "Netherlands" },
  { slug: "sweden", nameTh: "สวีเดน", nameEn: "Sweden" },
  { slug: "switzerland", nameTh: "สวิตเซอร์แลนด์", nameEn: "Switzerland" },
  { slug: "italy", nameTh: "อิตาลี", nameEn: "Italy" },
  { slug: "spain", nameTh: "สเปน", nameEn: "Spain" },
  { slug: "singapore", nameTh: "สิงคโปร์", nameEn: "Singapore" },
  { slug: "india", nameTh: "อินเดีย", nameEn: "India" },
  { slug: "newzealand", nameTh: "นิวซีแลนด์", nameEn: "New Zealand" },
  { slug: "russia", nameTh: "รัสเซีย", nameEn: "Russia" },
  { slug: "uae", nameTh: "สหรัฐอาหรับเอมิเรตส์", nameEn: "UAE" },
  { slug: "philippines", nameTh: "ฟิลิปปินส์", nameEn: "Philippines" },
  { slug: "vietnam", nameTh: "เวียดนาม", nameEn: "Vietnam" },
  { slug: "taiwan", nameTh: "ไต้หวัน", nameEn: "Taiwan" },
] as const;
